import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { IonRouterOutlet,ToastController,NavController,Platform,LoadingController,AlertController,ModalController } from '@ionic/angular';
import { TermsPage } from '../terms/terms.page';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})

export class ContactPage implements OnInit {

  hasTerm = false;
  logo:any;
  url:any;
  constructor(private routerOutlet: IonRouterOutlet,public modalController: ModalController,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

  if(localStorage.getItem(Constant.logo))
    {
      this.logo = localStorage.getItem(Constant.logo);
      this.url  = localStorage.getItem(Constant.url);
    }

  }

  ngOnInit()
  {

  }

  term()
  {
    this.hasTerm = this.hasTerm == true ? false : true;

    if(this.hasTerm == true)
    {
      this.terms();
    }
  }

  async signup(data)
  {
    if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(data.email))
    {
      const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000

    });
    await loading.present();

    this.server.contact(data).subscribe((response:any) => {

    this.presentToast("Thank You! We have received your message. We will contact you soon.");

    this.nav.navigateForward('/main');

    loading.dismiss();

    });
    }
    else
    {
      this.presentToast("Please enter valid email");
    }
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }

async terms() {
    const modal = await this.modalController.create({
      component: TermsPage,
      animated:true,
      mode:'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss:false,
      swipeToClose: true,
      presentingElement: this.routerOutlet.nativeEl

    });

   modal.onDidDismiss().then(data=>{


    })

    return await modal.present();
  }
}
